module.exports = __webpack_public_path__ + "img/cloth_g3_hat-07.3035f63c.svg";